import cabri from "../app/cabri-app";
import {GeomObject} from "./geom-object";
import * as BABYLON from "babylonjs/babylon.max";

class Conic extends GeomObject {

    constructor (objectId) {
        super(objectId);
        this.conicType = null;
        this.lastCoords = [0, 0, 0, 1, 0, 0];
        this.curve_color1 =
            super.getColorAttribute("curve_color1", "#00FFFF");
        this.curve_radius =
            super.getStyleAttribute("curve_radius", "2");
        this.tube = null;
        this.positions = []; this.oldBreakages = [];
    }

    conicTypes = {  0: "undefined",
        1: "circular",
        2: "ellipse",
        3: "parabola",
        4: "hyperbola",
        5: "two_lines",
        6: "one_line",
        7: "circle",
        8: "general"
    }

    updateFromPeer () {
        if (this.objectId === 0) return;
        let coords = null;
        const typeInt = cabri.emsc.getConicType(this.objectId);
        if (typeInt === 0) return;
        this.conicType = this.conicTypes[typeInt];
        if (true) { // was: this.conicType === "circle" || this.conicType === "ellipse"
            try {
                coords = cabri.emsc.renderAsMeshConic(this.objectId,1,true);
                let c = this.lastCoords;

                const oldL = c.length, newL = coords.length;
                let changed = this.forceUpdateInNextCycle || newL !== oldL;

                if(changed) { // big change, reset arrays
                    this.lastCoords = c = new Array(newL);
                } else { // small change, check or update values individually
                    for(let i=0; !changed && i<newL; i++)
                        changed = changed || coords[i] !== c[i];
                }

                if(changed) {
                    for(let i=0; i<newL; i++) c[i] = coords[i];
                    this.updateTubes(c);
                    this.forceUpdateInNextCycle = false;
                    return true;
                }
                return false;
            } catch (e) {
                console.log(
                    "Trouble at updateFromPeer (" + this.constructor.name +
                    ").");
                console.log(e);
            } finally {
                if (coords) try {
                    cabri.emsc._free(coords);
                } catch (e) {
                }
            }
        }
    }

    updateTubes (c) {
        // split breakages' list apart
        const breakagesCount = Math.floor(c[c.length-1]);
        const numCoords = c.length-breakagesCount-1;
        const breakages = new Array(breakagesCount+1);
        let sameBreakages = true;
        for(let i=0; i<breakagesCount; i++) {
            breakages[i] = Math.floor(c[numCoords+i]);
            if(this.oldBreakages[i] !== breakages[i]) sameBreakages = false;
        }
        breakages[breakagesCount] = c.length- breakagesCount-1;
        // now breakages is a growing sequence of integers with the last being the max index
        // ... it indicates the places where a new tybe needs to be started

        const l  = numCoords.length/3;
        if (this.tubes && this.positions.length === l+1 && sameBreakages ) {

            const l = (c.length-breakages.length);
            let tubeNum = 0, cNum =0;

            while(cNum<l) {
                const maxNum = breakages[tubeNum],
                    pos = this.positions[tubeNum];
                for(let i=0; cNum<maxNum;) {
                    const v= pos[i];
                    v.x = c[cNum], v.y = c[cNum+2]; v.z = c[cNum+1];
                    i++; cNum+=3;
                }
                this.tube = BABYLON.MeshBuilder.CreateTube("conic" + this.objectId,
                    {path:p, instance: this.tubes[tubeNum]});
            }
        }
        else {
            this.oldBreakages = new Array(...breakages);
            this.createTubes(c, breakages);
        }

    }

    createTubes (c, breakages) {
        try {
            if (this.tubes) {
                for (let t of this.tubes) {
                    if (t) {
                        t.dispose(false, true);
                    }
                }
            }
            if (this.noDisplay || this.hidden) {
                return;
            }

            const l = (c.length - breakages.length);
            this.tubes = new Array(breakages.length);
            this.positions = new Array(breakages.length);
            let tubeNum = 0, cNum = 0;
            while (cNum < l) {
                // we create a tube with positions in c with index cNum to breakages[tubeNum]
                const maxNum = breakages[tubeNum];
                let pos = this.positions[tubeNum] = new Array((maxNum - cNum) / 3);
                let i = 0;
                while (cNum < maxNum) {
                    pos[i] = new BABYLON.Vector3(c[cNum], c[cNum + 2], c[cNum + 1]);
                    i++;
                    cNum += 3;
                }
                if (i < pos.length) {
                    pos = this.positions[tubeNum] = pos.splice(0, pos.length - i);
                }
                if (i > 0) {
                    const tube = this.tubes[tubeNum++] = BABYLON.MeshBuilder.CreateTube("conic" + this.objectId,
                        {path: pos, radius: 0.05 * this.curve_radius, updatable: true}, cabri.scene);
                    super.markColor(tube, this.curve_color1);
                }
            }
        } catch (e) {
            console.log(e);
        }
    }

}

export {Conic};